import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "layout": "full",
  "title": "SDG 4 Indicators",
  "lead": "Ensure inclusive and equitable quality education and promote lifelong learning opportunities for all"
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    p: "p",
    ..._provideComponents(),
    ...props.components
  }, {IndicatorRow, IndicatorSection, IndicatorTable, TargetFourLogo, ThemeLabel, Title} = _components;
  if (!IndicatorRow) _missingMdxReference("IndicatorRow", true);
  if (!IndicatorSection) _missingMdxReference("IndicatorSection", true);
  if (!IndicatorTable) _missingMdxReference("IndicatorTable", true);
  if (!TargetFourLogo) _missingMdxReference("TargetFourLogo", true);
  if (!ThemeLabel) _missingMdxReference("ThemeLabel", true);
  if (!Title) _missingMdxReference("Title", true);
  return _jsxs(_Fragment, {
    children: [_jsx(TargetFourLogo, {}), "\n", _jsx(Title, {
      children: "SDG 4 Indicators"
    }), "\n", _jsx(_components.p, {
      children: "Ensure inclusive and equitable quality education and promote lifelong learning opportunities for all"
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-41",
        children: "Target 4.1"
      }), _jsxs(_components.p, {
        children: ["By 2030, ensure that all girls and boys complete free, equitable and quality primary and secondary education leading to relevant and effective learning outcomes. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000391406/PDF/391406eng.pdf.multi.page=166",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.1.0",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.0",
          children: _jsx(_components.p, {
            children: "Proportion of children/young people prepared for the future, by sex"
          })
        }), _jsxs(IndicatorRow, {
          id: "4.1.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.1/",
          global: true,
          children: [_jsx(_components.p, {
            children: "Proportion of children and young people (a) in Grade 2 or 3; (b) at the end of primary\neducation; and (c) at the end of lower secondary education achieving at least a minimum\nproficiency level in (i) reading and (ii) mathematics, by sex"
          }), _jsx(ThemeLabel, {
            theme: "learning",
            id: "4.1.1a"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.1.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.2",
          global: true,
          children: _jsx(_components.p, {
            children: "Completion rate (primary education, lower secondary education, upper secondary education)"
          })
        }), _jsx(IndicatorRow, {
          id: "4.1.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.3",
          children: _jsx(_components.p, {
            children: "Gross intake ratio to the last grade (primary education, lower secondary education)"
          })
        }), _jsxs(IndicatorRow, {
          id: "4.1.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.4",
          children: [_jsx(_components.p, {
            children: "Out-of-school rate (1 year before primary, primary education, lower secondary education, upper secondary education)"
          }), _jsx(ThemeLabel, {
            theme: "access",
            id: "4.1.4"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.1.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.5",
          children: [_jsx(_components.p, {
            children: "Percentage of children over-age for grade (primary education, lower secondary education)"
          }), _jsx(ThemeLabel, {
            theme: "access",
            id: "4.1.5"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.1.6",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.6",
          children: [_jsx(_components.p, {
            children: "Administration of a nationally-representative learning assessment (a) in Grade 2 or 3; (b) at the end of primary education; and (c) at the end of lower secondary education"
          }), _jsx(ThemeLabel, {
            theme: "access",
            id: "4.1.6"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.1.7",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.1/i4.1.7",
          children: _jsx(_components.p, {
            children: "Number of years of (a) free and (b) compulsory primary and secondary education guaranteed in legal frameworks"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-42",
        children: "Target 4.2"
      }), _jsxs(_components.p, {
        children: ["By 2030, ensure that all girls and boys have access to quality early childhood development, care and pre-primary education so that they are ready for primary education. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000391406/PDF/391406eng.pdf.multi.page=186",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.2.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.1",
          global: true,
          children: _jsx(_components.p, {
            children: "Proportion of children aged 24-59 months who are developmentally on track in health, learning and psychosocial well-being, by sex"
          })
        }), _jsxs(IndicatorRow, {
          id: "4.2.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.2",
          global: true,
          children: [_jsx(_components.p, {
            children: "Participation rate in organized learning (one year before the official primary entry age), by sex"
          }), _jsx(ThemeLabel, {
            theme: "access",
            id: "4.2.2"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.2.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.3",
          children: _jsx(_components.p, {
            children: "Percentage of children under 5 years experiencing positive and stimulating home learning environments"
          })
        }), _jsx(IndicatorRow, {
          id: "4.2.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.4",
          children: _jsx(_components.p, {
            children: "Net early childhood education enrolment ratio in (a) pre-primary education and (b) early childhood educational development"
          })
        }), _jsx(IndicatorRow, {
          id: "4.2.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.2/i4.2.5",
          children: _jsx(_components.p, {
            children: "Number of years of (a) free and (b) compulsory pre-primary education guaranteed in legal frameworks"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-43",
        children: "Target 4.3"
      }), _jsxs(_components.p, {
        children: ["By 2030, ensure equal access for all women and men to affordable and quality technical, vocational and tertiary education, including university. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000391406/PDF/391406eng.pdf.multi.page=198",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.3.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.3/i4.3.1",
          global: true,
          children: _jsx(_components.p, {
            children: "Participation rate of youth and adults in formal and non-formal education and training in the previous 12 months, by sex"
          })
        }), _jsx(IndicatorRow, {
          id: "4.3.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.3/i4.3.2",
          children: _jsx(_components.p, {
            children: "Gross enrolment ratio for tertiary education by sex"
          })
        }), _jsx(IndicatorRow, {
          id: "4.3.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.3/i4.3.3",
          children: _jsx(_components.p, {
            children: "Participation rate in technical-vocational programmes (15- to 24-year-olds) by sex"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-44",
        children: "Target 4.4"
      }), _jsxs(_components.p, {
        children: ["By 2030, substantially increase the number of youth and adults who have relevant skills, including technical and vocational skills, for employment, decent jobs and entrepreneurship. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000391406/PDF/391406eng.pdf.multi.page=212",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.4.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.4/i4.4.1",
          global: true,
          children: _jsx(_components.p, {
            children: "Proportion of youth and adults with information and communications technology (ICT) skills, by type of skill"
          })
        }), _jsx(IndicatorRow, {
          id: "4.4.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.4/i4.4.2",
          children: _jsx(_components.p, {
            children: "Percentage of youth/adults who have achieved at least a minimum level of proficiency in digital literacy skills"
          })
        }), _jsx(IndicatorRow, {
          id: "4.4.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.4/i4.4.3",
          children: _jsx(_components.p, {
            children: "Youth/adult educational attainment rates by age group and level of education"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-45",
        children: "Target 4.5"
      }), _jsxs(_components.p, {
        children: ["By 2030, eliminate gender disparities in education and ensure equal access to all levels of education and vocational training for the vulnerable, including persons with disabilities, indigenous peoples and children in vulnerable situations. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000391406/PDF/391406eng.pdf.multi.page=222",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.5.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i.4.5.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "Parity indices (female/male, rural/urban, bottom/top wealth quintile and others such as disability status, indigenous peoples and conflict-affected, as data become available) for all education indicators on this list that can be disaggregated"
          }), _jsx(ThemeLabel, {
            theme: "equity",
            id: "4.5.1"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.5.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.2",
          children: _jsx(_components.p, {
            children: "Percentage of students in a) early grades, b) primary education, and c) at the end of lower secondary education who have their first or home language as the language of instruction"
          })
        }), _jsx(IndicatorRow, {
          id: "4.5.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.3",
          children: _jsx(_components.p, {
            children: "Existence of funding mechanisms to reallocate education resources to disadvantaged populations"
          })
        }), _jsx(IndicatorRow, {
          id: "4.5.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.4",
          children: _jsx(_components.p, {
            children: "Education expenditure per student by level of education and source of funding"
          })
        }), _jsxs(IndicatorRow, {
          id: "4.5.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.5",
          children: [_jsx(_components.p, {
            children: "Percentage of total aid to education allocated to least developed countries"
          }), _jsx(ThemeLabel, {
            theme: "finance",
            id: "4.5.5"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.5.6",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.5/i4.5.6",
          children: [_jsx(_components.p, {
            children: "Percentage of total aid to education allocated to least developed countries"
          }), _jsx(ThemeLabel, {
            theme: "finance",
            id: "4.5.6"
          })]
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-46",
        children: "Target 4.6"
      }), _jsxs(_components.p, {
        children: ["By 2030, ensure that all youth and a substantial proportion of adults, both men and women, achieve literacy and numeracy. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000391406/PDF/391406eng.pdf.multi.page=234",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.6.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.6/i4.6.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "Proportion of population in a given age group achieving at least a fixed level of proficiency in functional (a) literacy and (b) numeracy skills, by sex"
          }), _jsx(ThemeLabel, {
            theme: "learning",
            id: "4.6.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.6.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.6/i4.6.2",
          children: [_jsx(_components.p, {
            children: "Youth/adult literacy rate"
          }), _jsx(ThemeLabel, {
            theme: "learning",
            id: "4.6.2"
          })]
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-47",
        children: "Target 4.7"
      }), _jsxs(_components.p, {
        children: ["By 2030, ensure that all learners acquire the knowledge and skills needed to promote sustainable development, including, among others, through education for sustainable development and sustainable lifestyles, human rights, gender equality, promotion of a culture of peace and nonviolence, global citizenship and appreciation of cultural diversity and of culture’s contribution to sustainable development. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000391406/PDF/391406eng.pdf.multi.page=244",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsx(IndicatorRow, {
          id: "4.7.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.1",
          global: true,
          children: _jsx(_components.p, {
            children: "Extent to which (i) global citizenship education and (ii) education for sustainable development are mainstreamed in (a) national education policies; (b) curricula; (c) teacher education and (d) student assessment"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.2",
          children: _jsx(_components.p, {
            children: "Percentage of schools that provide life skills-based HIV and sexuality education"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.3",
          children: _jsx(_components.p, {
            children: "Extent to which green policy intentions are mainstreamed in curriculum documents"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.4",
          children: _jsx(_components.p, {
            children: "Percentage of students in lower secondary showing adequate understanding of issues relating to global citizenship and sustainability"
          })
        }), _jsx(IndicatorRow, {
          id: "4.7.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.7/i4.7.5",
          children: _jsx(_components.p, {
            children: "Percentage of students in lower secondary showing proficiency in knowledge of environmental science and geoscience"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-4a",
        children: "Target 4.a"
      }), _jsxs(_components.p, {
        children: ["Build and upgrade education facilities that are child, disability and gender sensitive and provide safe, non-violent, inclusive and effective learning environments for all. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000391406/PDF/391406eng.pdf.multi.page=254",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.a.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.a/i4.a.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "Proportion of schools offering basic services, by type of service"
          }), _jsx(ThemeLabel, {
            theme: "quality",
            id: "4.a.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.a.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.a/i4.a.2",
          children: [_jsx(_components.p, {
            children: "Percentage of students experiencing bullying in the last 12 months in a) primary, and b) lower secondary education"
          }), _jsx(ThemeLabel, {
            theme: "quality",
            id: "4.a.2"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.a.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.a/i4.a.3",
          children: _jsx(_components.p, {
            children: "Number of attacks on students, personnel and institutions"
          })
        }), _jsx(IndicatorRow, {
          id: "4.a.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring",
          children: _jsx(_components.p, {
            children: "Proportion of school attending children receiving school meals"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-4b",
        children: "Target 4.b"
      }), _jsxs(_components.p, {
        children: ["By 2020, substantially expand globally the number of scholarships available to developing countries, in particular least developed countries, small island developing States and African countries, for enrolment in higher education, including vocational training and information and communications technology, technical, engineering and scientific programmes, in developed countries and other developing countries. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000391406/PDF/391406eng.pdf.multi.page=268",
          children: "See latest GEM Report chapter"
        })]
      }), _jsx(IndicatorTable, {
        children: _jsx(IndicatorRow, {
          id: "4.b.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.b/i4.b.1",
          global: true,
          children: _jsx(_components.p, {
            children: "Volume of official development assistance flows for scholarships by sector and type of study"
          })
        })
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "target-4c",
        children: "Target 4.c"
      }), _jsxs(_components.p, {
        children: ["By 2030, substantially increase the supply of qualified teachers, including through international cooperation for teacher training in developing countries, especially least developed countries and small island developing States. ", _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000391406/PDF/391406eng.pdf.multi.page=276",
          children: "See latest GEM Report chapter"
        })]
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "4.c.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.1",
          global: true,
          children: [_jsx(_components.p, {
            children: "Proportion of teachers with the minimum required qualifications, by education level"
          }), _jsx(ThemeLabel, {
            theme: "quality",
            id: "4.c.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "4.c.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.2",
          children: [_jsx(_components.p, {
            children: "Pupil-trained teacher ratio by education level"
          }), _jsx(ThemeLabel, {
            theme: "quality",
            id: "4.c.2"
          })]
        }), _jsx(IndicatorRow, {
          id: "4.c.3",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.3",
          children: _jsx(_components.p, {
            children: "Percentage of teachers qualified according to national standards, by education level and type of institution"
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.4",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.4",
          children: _jsx(_components.p, {
            children: "Pupil-qualified teacher ratio by education level"
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.5",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.5",
          children: _jsx(_components.p, {
            children: "Average teacher salary relative to other professions requiring a comparable level of qualification"
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.6",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.6",
          children: _jsx(_components.p, {
            children: "Teacher attrition rate by education level"
          })
        }), _jsx(IndicatorRow, {
          id: "4.c.7",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t4.c/i4.c.7",
          children: _jsx(_components.p, {
            children: "Percentage of teachers who received in-service training in the last 12 months by type of training"
          })
        })]
      })]
    }), "\n", _jsxs(IndicatorSection, {
      children: [_jsx(_components.h2, {
        id: "finance",
        children: "Finance"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000391406/PDF/391406eng.pdf.multi.page=287",
          children: "See latest GEM Report chapter"
        })
      }), _jsxs(IndicatorTable, {
        children: [_jsxs(IndicatorRow, {
          id: "F.1",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/govexp",
          children: [_jsx(_components.p, {
            children: "Government expenditure on education as a percentage of GDP"
          }), _jsx(ThemeLabel, {
            theme: "finance",
            id: "F.1"
          })]
        }), _jsxs(IndicatorRow, {
          id: "F.2",
          link: "https://databrowser.uis.unesco.org/browser/EDUCATION/UIS-SDG4Monitoring/t1.a/i1.a.2",
          children: [_jsx(_components.p, {
            children: "Government expenditure on education as a percentage of total government expenditure"
          }), _jsx(ThemeLabel, {
            theme: "finance",
            id: "F.2"
          })]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
